import React, { Component } from "react";
import { toast } from "react-toastify";
import "./SyncToSMRModal.scss";
import Modal from "../../../UIComponents/CustomModal/Modal";
import { ReactComponent as TwitterIcon } from "../../../../assets/svg/twitter-logo.svg";
import Checkbox from "semantic-ui-react/dist/es/modules/Checkbox";
// import { ReactComponent as InstagramIcon } from "../../../../assets/svg/instagram.svg";
import { ReactComponent as FacebookIcon } from "../../../../assets/svg/facebook-icon.svg";
import { ReactComponent as LinkedInIcon } from "../../../../assets/svg/linkedin.svg";
import Scrollbars from "react-custom-scrollbars";
import instagramIcon from "../../../../assets/svg/instagram.svg";
import PlatformIcon from "../../SMR/Icons/PlatformIcon";

class SyncToSMRModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageIds: "",
            pageLists: [],
        };
    }
    componentDidMount() {
        let pageLists = this.props.smrPages
            ?.filter((p) => {
                return this.props.open?.toLowerCase()?.includes(p.platform) && p?.token_type !== "group";
            })
            .sort((a, b) => {
                if (a.status === "Active" && b.status !== "Active") {
                    return -1; // a should come before b
                } else if (a.status !== "Active" && b.status === "Active") {
                    return 1; // b should come before a
                } else {
                    return 0; // order remains unchanged
                }
            });

        this.setState({ pageLists });
    }
    handlePageId = (pageIds) => {
        this.setState({ pageIds });
    };

    getImgPlaceholder = (p) => {
        return ["instagram", "facebook"].includes(p.platform)
            ? p?.page_username
                ? p?.page_username.slice(0, 1)
                : p?.page_name?.slice(0, 1)
            : p.page_name?.slice(0, 1);
    };

    getPlatformIcon = (p) => {
        switch (p.platform) {
            case "twitter":
                return <TwitterIcon />;

            case "instagram":
                // return <InstagramIcon />;
                return <img src={instagramIcon} className="instagram__icon" alt="instagram icon" />;

            case "facebook":
                return <FacebookIcon />;

            case "linkedin":
                return <LinkedInIcon />;

            default:
                return <TwitterIcon />;
        }
    };

    getSocialList = () => {
        // console.log("first", this.props.open);
        return (
            <>
                {this.state.pageLists?.length > 0 ? (
                    this.state.pageLists.map((p) => {
                        return (
                            // ["twitter", "instagram", "facebook"].includes(p.platform) && (
                            // this.props.open &&
                            // this.props.open?.toLowerCase()?.includes(p.platform) &&
                            // p?.token_type !== "group" && (
                            <div
                                className={`conversation-dropdown-custom-checkbox`}
                                key={p.id}
                                onClick={() => p.status == "Active" && this.handlePageId(p.page_id)}>
                                <Checkbox checked={p.page_id == this.state.pageIds} disabled={p.status !== "Active"} />

                                <div className="page-image">
                                    {p.page_profile_pic ? (
                                        <img src={p.page_profile_pic} />
                                    ) : (
                                        <div className="no-image-placeholder">
                                            {
                                                this.getImgPlaceholder(p)
                                                // p.page_name.slice(0, 1)
                                            }
                                        </div>
                                    )}

                                    <PlatformIcon platform={p.platform} />
                                    {/* {this.getPlatformIcon(p)} */}
                                </div>

                                <span className={`name ${p.status == "Active" ? "" : "Inactive"}`}>
                                    {["instagram", "facebook"].includes(p.platform) ? (p?.page_username ? p?.page_username : p?.page_name) : p.page_name}
                                    {`${p.status === "Active" ? "" : " (Inactive)"}`}
                                </span>

                                <div className="facade"></div>
                            </div>
                            // )
                        );
                    })
                ) : (
                    <p className="no__page__connected">No page connected.</p>
                )}
            </>
        );
    };

    applySyncModal = () => {
        if (this.state.pageIds == "") {
            toast.error("Please select a page.");
        } else {
            this.props.syncedToSmr(this.state.pageIds);
        }
    };
    hideSyncModal = () => {
        this.setState({ pageIds: "" });
        this.props.hideModal();
    };

    render() {
        return (
            <Modal className={`change-review-status-modal`} show={this.props.open} onClose={() => this.hideSyncModal()}>
                <Modal.Header>Select Social Profile</Modal.Header>
                <Modal.Content style={{ height: this.state.pageLists?.length === 0 ? "80px" : "150px" }} className={`conversation-content-modal`}>
                    <Scrollbars>{this.getSocialList()}</Scrollbars>
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={() => this.hideSyncModal()}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton
                        filled
                        disabled={this.state.pageLists?.length === 0 || this.props.syncPostLoading}
                        onClick={() => this.applySyncModal()}>
                        Apply
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default SyncToSMRModal;
